// Ported 1:1 from the Webflow page markup (scraped/). Class names and data-w-id
// attributes must stay intact: webflow.css and the IX2/Lottie runtime key off them.
import ContactForm from "@/components/ContactForm";

export default function ContactPage() {
  return (
    <>
      <section className="section-top">
        <div style={{ opacity: "0" }} className="content">
          <div className="block-top">
            <h1 className="heading-top h1-as-h2">Want to explore partnering with us or one of our ventures?</h1>
            <p className="paragraph-top">Write to our leadership team via email or on LinkedIn or contact us via the form below</p>
          </div>
        </div>
      </section>
      <section className="section">
        <div style={{ opacity: "0" }} className="content">
          <div className="lottie-wrapper">
            <div className="contact-lottie">
              <div className="contact-lottie-link">
                <div className="block-icon-contact-lottie">
                  <img src="/assets/cdn/655dfd1658ca065efffe0f1f_image.webp" loading="eager" sizes="(max-width: 479px) 27vw, (max-width: 767px) 13vw, (max-width: 1279px) 80px, (max-width: 1439px) 6vw, 80px" srcSet="/assets/cdn/655dfd1658ca065efffe0f1f_image-p-500.webp 500w, /assets/cdn/655dfd1658ca065efffe0f1f_image-p-800.webp 800w, /assets/cdn/655dfd1658ca065efffe0f1f_image-p-1080.webp 1080w, /assets/cdn/655dfd1658ca065efffe0f1f_image-p-1600.webp 1600w, /assets/cdn/655dfd1658ca065efffe0f1f_image.webp 2000w" alt="Rossen Zhivkov" className="icon-contact-lottie team" />
                </div>
                <div className="block-heading-contact-lottie members">
                  <div className="members-heading">
                    <h4 className="heading-contact-lottie memebers">Rossen Zhivkov</h4>
                    <div className="text-contact-lottie members">CEO</div>
                  </div>
                  <div className="members-links">
                    <div className="memebr-link">
                      <a href="mailto:rossen@abilitics.com" className="member-icon w-inline-block">
                        <div className="w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21.387" height="20" viewBox="0 0 21.387 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <path className="a" d="M113.751,17.109l-9.859-7.114a1.408,1.408,0,0,0-1.646,0l-9.88,7.114h0V28.322a1.407,1.407,0,0,0,1.407,1.407h18.573a1.407,1.407,0,0,0,1.407-1.407V17.109Zm-9.881,7.118a1.408,1.408,0,0,1-1.646,0L92.366,17.11h21.385Z" transform="translate(-92.365 -9.729)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open email</div>
                      </a>
                      <a href="mailto:rossen@abilitics.com" className="text-link">rossen@abilitics.com</a>
                    </div>
                    <div className="memebr-link">
                      <a href="https://www.linkedin.com/in/rossenzhivkov/" target="_blank" className="w-inline-block">
                        <div className="member-icon w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="19.99" height="20" viewBox="0 0 19.99 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <rect className="a" width="4.127" height="13.333" transform="translate(0.396 6.667)" />
                            <path className="a" d="M2.44,0a2.461,2.461,0,0,0,0,4.921h0a2.45,2.45,0,0,0,2.44-2.46v0A2.449,2.449,0,0,0,2.44,0" transform="translate(0)" />
                            <path className="a" d="M15.139,6.26a4.646,4.646,0,0,0-4.018,2.2v-1.8H7.161V19.994h3.96V13c0-1.874.862-2.99,2.515-2.99,1.517,0,2.246,1.072,2.246,2.99v7H19.99V11.558c0-3.57-2.025-5.3-4.851-5.3" transform="translate(0)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open linkedin</div>
                      </a>
                      <a href="https://www.linkedin.com/in/rossenzhivkov/" target="_blank" className="text-link">rossenzhivkov</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contact-lottie-link a2">
                <div className="block-icon-contact-lottie">
                  <img src="/assets/cdn/655e0ced940937326c9db779_Jivko%20Petiov%20Circle.png" loading="eager" alt="Jivko Petiov" className="icon-contact-lottie team" />
                </div>
                <div className="block-heading-contact-lottie members">
                  <div className="members-heading">
                    <h4 className="heading-contact-lottie memebers">Jivko Petiov</h4>
                    <div className="text-contact-lottie members">CTO</div>
                  </div>
                  <div className="members-links">
                    <div className="memebr-link">
                      <a href="mailto:jivko@abilitics.com" className="member-icon w-inline-block">
                        <div className="w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21.387" height="20" viewBox="0 0 21.387 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <path className="a" d="M113.751,17.109l-9.859-7.114a1.408,1.408,0,0,0-1.646,0l-9.88,7.114h0V28.322a1.407,1.407,0,0,0,1.407,1.407h18.573a1.407,1.407,0,0,0,1.407-1.407V17.109Zm-9.881,7.118a1.408,1.408,0,0,1-1.646,0L92.366,17.11h21.385Z" transform="translate(-92.365 -9.729)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open email</div>
                      </a>
                      <a href="mailto:jivko@abilitics.com" className="text-link">jivko@abilitics.com</a>
                    </div>
                    <div className="memebr-link">
                      <a href="https://www.linkedin.com/in/jivkopetiov/" target="_blank" className="w-inline-block">
                        <div className="member-icon w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="19.99" height="20" viewBox="0 0 19.99 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <rect className="a" width="4.127" height="13.333" transform="translate(0.396 6.667)" />
                            <path className="a" d="M2.44,0a2.461,2.461,0,0,0,0,4.921h0a2.45,2.45,0,0,0,2.44-2.46v0A2.449,2.449,0,0,0,2.44,0" transform="translate(0)" />
                            <path className="a" d="M15.139,6.26a4.646,4.646,0,0,0-4.018,2.2v-1.8H7.161V19.994h3.96V13c0-1.874.862-2.99,2.515-2.99,1.517,0,2.246,1.072,2.246,2.99v7H19.99V11.558c0-3.57-2.025-5.3-4.851-5.3" transform="translate(0)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open linkedin</div>
                      </a>
                      <a href="https://www.linkedin.com/in/jivkopetiov/" target="_blank" className="text-link">jivkopetiov</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contact-lottie-link a3">
                <div className="block-icon-contact-lottie">
                  <img src="/assets/cdn/6565a9a91db66a9a508aab80_mail%20icon.svg" loading="eager" alt="" className="icon-contact-lottie" />
                </div>
                <div className="block-heading-contact-lottie members">
                  <div className="members-heading">
                    <h4 className="heading-contact-lottie memebers">Email</h4>
                  </div>
                  <div className="members-links">
                    <div className="memebr-link">
                      <a href="mailto:office@abilitics.com" className="member-icon w-inline-block">
                        <div className="w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21.387" height="20" viewBox="0 0 21.387 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <path className="a" d="M113.751,17.109l-9.859-7.114a1.408,1.408,0,0,0-1.646,0l-9.88,7.114h0V28.322a1.407,1.407,0,0,0,1.407,1.407h18.573a1.407,1.407,0,0,0,1.407-1.407V17.109Zm-9.881,7.118a1.408,1.408,0,0,1-1.646,0L92.366,17.11h21.385Z" transform="translate(-92.365 -9.729)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open email</div>
                      </a>
                      <a href="mailto:office@abilitics.com" className="text-link">office@abilitics.com</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-w-id="07a5224a-2f76-5a8b-6449-d53585f6c3d6" className="lottie">
              <div className="lines-c1">
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
              </div>
              <div className="lines-c2">
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
              </div>
              <div className="block-lottie">
                <div data-w-id="07a5224a-2f76-5a8b-6449-d53585f6c3e5" data-is-ix2-target="1" className="lottie-animation-1" data-animation-type="lottie" data-src="/assets/cdn/6560a307da449238f4d1b55d_Animation%20C1.json" data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-default-duration="1.3" data-duration="0" data-loading="eager" />
                <div className="lottie-animation-2" data-w-id="07a5224a-2f76-5a8b-6449-d53585f6c3e6" data-animation-type="lottie" data-src="/assets/cdn/6560a30751d6ae844977d430_Animation%20C2.json" data-loop="1" data-direction="1" data-autoplay="1" data-is-ix2-target="0" data-renderer="svg" data-default-duration="12" data-duration="0" data-loading="eager" />
              </div>
            </div>
          </div>
          <div className="contact">
            <div className="subtitle blue">
              contact form
              <br />
            </div>
            <h2 className="heading">Let&#x27;s get in touch</h2>
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}
